<template>
    <div></div>
</template>

<script>
    export default {
        name: "Empty",
        created() {

        }
    }
</script>

<style scoped>

</style>